import { Link } from 'react-router-dom'
import { Sparkles, Mail, Phone, MapPin, Instagram, Facebook } from 'lucide-react'

const footerLinks = {
  services: [
    { label: 'Gel Nails', href: '/services#gel-nails' },
    { label: 'Acrylic Nails', href: '/services#acrylic-nails' },
    { label: 'French Nails', href: '/services#french-nails' },
    { label: 'Wedding Nails', href: '/services#wedding-nails' },
    { label: 'Luxury Manicure', href: '/services#luxury-manicure' },
    { label: 'Luxury Pedicure', href: '/services#luxury-pedicure' },
  ],
  company: [
    { label: 'About Us', href: '/about' },
    { label: 'Gallery', href: '/gallery' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'Blog', href: '/blog' },
    { label: 'FAQ', href: '/faq' },
    { label: 'Contact', href: '/contact' },
  ],
  legal: [
    { label: 'Privacy Policy', href: '/privacy-policy' },
    { label: 'Terms & Conditions', href: '/terms-conditions' },
    { label: 'Cookie Policy', href: '/cookie-policy' },
    { label: 'Disclaimer', href: '/disclaimer' },
    { label: 'Accessibility', href: '/accessibility' },
  ],
}

export default function Footer() {
  return (
    <footer className="bg-luxury-pearl dark:bg-luxury-black border-t border-luxury-champagne/10" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-6">
              <Sparkles className="w-6 h-6 text-luxury-champagne" />
              <span className="font-display text-xl font-semibold">
                Nail<span className="text-luxury-champagne">Art</span>Pro
              </span>
            </Link>
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-6 leading-relaxed">
              Luxury Nail Art & Beauty Studio. Experience the finest nail care with our expert artists in Kolkata.
            </p>
            <div className="flex gap-3">
              <a href="https://instagram.com/nailartpro" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-luxury-champagne/10 text-luxury-champagne hover:bg-luxury-champagne/20 transition-colors" aria-label="Instagram">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://facebook.com/nailartpro" target="_blank" rel="noopener noreferrer" className="p-2 rounded-full bg-luxury-champagne/10 text-luxury-champagne hover:bg-luxury-champagne/20 transition-colors" aria-label="Facebook">
                <Facebook className="w-5 h-5" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold mb-6">Services</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-gray-600 dark:text-gray-400 hover:text-luxury-champagne transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold mb-6">Company</h3>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-gray-600 dark:text-gray-400 hover:text-luxury-champagne transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-semibold mb-6">Contact</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-luxury-champagne mt-0.5 shrink-0" />
                <span className="text-sm text-gray-600 dark:text-gray-400">Kolkata, West Bengal, India</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-luxury-champagne shrink-0" />
                <a href="tel:+919088066676" className="text-sm text-gray-600 dark:text-gray-400 hover:text-luxury-champagne transition-colors">
                  +91 90880 66676
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-5 h-5 text-luxury-champagne shrink-0" />
                <a href="mailto:nailartpro.kol@gmail.com" className="text-sm text-gray-600 dark:text-gray-400 hover:text-luxury-champagne transition-colors">
                  nailartpro.kol@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-luxury-champagne/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500 dark:text-gray-500">
            &copy; {new Date().getFullYear()} NailArtPro. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            {footerLinks.legal.map((link) => (
              <Link key={link.label} to={link.href} className="text-xs text-gray-500 dark:text-gray-500 hover:text-luxury-champagne transition-colors">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}